import { NgModule } from '@angular/core';
import { ComponentsModule } from 'components/components.module';
import { RedeemCodePage } from './redeem-code';
import { PagesModule } from 'pages/pages.module';

@NgModule({
    declarations: [RedeemCodePage],
    imports: [PagesModule, ComponentsModule]
})
export class RedeemCodePageModule {}
